import React, { useCallback, useEffect, useMemo } from "react";
import StickyHeaderDataTable from "../shared/sticky-header-data-table";
import Box from "@mui/material/Box";

import Loader from "../loader";
import currencyFormatter from "../../helpers/currencyFormatter";

export const MetricsType = {
  Departure: "departure",
  Arrival: "arrival",
  Combo: "combo",
};

const TABLE_NAME = {
  [MetricsType.Departure]: "Departure",
  [MetricsType.Arrival]: "Arrival",
  [MetricsType.Combo]: "Combo",
};

const CATEGORY_NAME = {
  isoCountry: "Country",
  region: "Region",
  subRegion: "Sub Region",
  isoRegion: "State",
  municipality: "Municipality",
  airport: "Airport",
};

const getColumns = (type, category) => ([
  {
    name: category ?
      type === MetricsType.Combo ?
        `${CATEGORY_NAME[category]} to ${CATEGORY_NAME[category]}` :
        CATEGORY_NAME[category] :
      "Category",
    selector: "category",
    minWidth: "150px",
    sortable: true,
  },
  {
    name: "Contracts",
    selector: "contracts",
    width: "120px",
    sortable: true,
  },
  {
    name: "Revenue",
    selector: "revenue",
    minWidth: "150px",
    cell: (row) => {
      if (
        (row?.revenue || row.revenue === 0) &&
        !isNaN(row?.revenue)
      ) {
        return currencyFormatter.format(row.revenue);
      }

      return "";
    },
    sortable: true,
  },
  {
    name: "Legs",
    selector: "legs",
    width: "100px",
    sortable: true,
  },
]);

export const MetricsLocationsTable = ({
  type,
  isLoading,
  category = null,
  data = [],
  pagination,
  sorting,
  fetchData,
  parentDispatch,
}) => {
  const handlePageChange = useCallback((page) => {
    parentDispatch({
      type: "pageChanged",
      payload: {
        page,
        type,
      },
    });
  }, [parentDispatch, type]);

  const handleRowsPerPageChange = useCallback((countPerPage) => {
    parentDispatch({
      type: "rowsPerPageChanged",
      payload: {
        countPerPage,
        type,
      },
    });
  }, [parentDispatch, type]);

  const handleSort = useCallback((column, sortDirection) => {
    parentDispatch({
      type: "sortingChanged",
      payload: {
        sortBy: column.selector,
        sortDirection,
        type,
      },
    });
  }, [parentDispatch, type]);

  useEffect(() => {
    fetchData({}, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pagination.currentPage,
    pagination.countPerPage,
    sorting.sortBy,
    sorting.sortDirection,
  ]);

  const columns = useMemo(() => getColumns(type, category || ""), [type, category]);

  return (
    <Box>
      <h5>{TABLE_NAME[type]} {CATEGORY_NAME[category] ?? ""}</h5>

      {
        category ? (
          <div
            className="server-pagination-table-container metrics-table-container data-table-compact-view shadow-none mt-0"
          >
            <StickyHeaderDataTable
              className="metrics-table"
              columns={columns}
              data={data ?? []}
              persistTableHead
              progressPending={isLoading}
              progressComponent={<Loader additionalClasses="metrics-table-loader"/>}

              // pagination
              pagination
              paginationServer
              paginationTotalRows={pagination.totalLength}
              paginationPerPage={pagination.countPerPage}
              paginationDefaultPage={pagination.currentPage}
              paginationRowsPerPageOptions={[10, 25]}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              paginationResetDefaultPage={false}

              // sorting
              sortServer
              onSort={handleSort}
              defaultSortField={sorting.sortBy}
              sortDirection={sorting.sortDirection}
            />
          </div>
        ) : (
          <div>Please select {type} category</div>
        )
      }
    </Box>
  );
};
